export default "__VITE_ASSET__DkIOC6lD__"